import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>

      <p>
        Welcome to SpoFlex (&quot;we&quot;, &quot;our&quot;, or &quot;us&quot;). Your privacy is
        important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard
        your information when you use our mobile application (&quot;SpoFlex&quot; or
        &quot;App&quot;) available on the Google Play Store and Apple App Store.
      </p>
      <p>
        By using SpoFlex, you agree to the collection and use of information in accordance with this
        Privacy Policy.
      </p>

      <h2>1. Information We Collect</h2>

      <h3>a. Personal Information</h3>
      <p>When you create an account or use certain features, we may collect:</p>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Profile photo (if uploaded)</li>
        <li>Other information you provide voluntarily</li>
      </ul>

      <h3>b. Usage Data</h3>
      <p>
        We may collect information about your device and how you interact with the app, such as:
      </p>
      <ul>
        <li>Device type and OS</li>
        <li>App version</li>
        <li>IP address</li>
        <li>Date and time of use</li>
        <li>Feature usage and interactions</li>
      </ul>

      <h3>c. Location Data (if enabled)</h3>
      <p>
        If you allow, we may collect your approximate or precise location to provide location-based
        services.
      </p>

      <h3>d. Cookies and Similar Technologies</h3>
      <p>
        We may use cookies or similar technologies to improve app performance and personalize your
        experience.
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>We use the collected data to:</p>
      <ul>
        <li>Provide, operate, and maintain the app</li>
        <li>Improve and personalize user experience</li>
        <li>Communicate with you regarding updates or support</li>
        <li>Monitor usage trends and performance</li>
        <li>Prevent fraud and ensure security</li>
      </ul>

      <h2>3. Sharing Your Information</h2>
      <p>We do not sell your personal data. We may share your data with:</p>
      <ul>
        <li>
          <strong>Service Providers:</strong> To perform services on our behalf (e.g., hosting,
          analytics)
        </li>
        <li>
          <strong>Legal Authorities:</strong> If required by law or to protect our rights
        </li>
        <li>
          <strong>Partners:</strong> With your consent or when necessary for a specific feature
        </li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We use administrative, technical, and physical safeguards to protect your data. However, no
        system can be 100% secure, and we cannot guarantee the absolute security of your
        information.
      </p>

      <h2>5. Your Rights and Choices</h2>
      <p>Depending on your location, you may have rights to:</p>
      <ul>
        <li>Access, update, or delete your personal data</li>
        <li>Withdraw consent at any time</li>
        <li>Opt out of data collection or marketing communications</li>
      </ul>
      <p>
        To exercise these rights, please contact us at:{" "}
        <a href="mailto:support@spoflex.com">support@spoflex.com</a>
      </p>

      <h2>6. Children&#39;s Privacy</h2>
      <p>
        SpoFlex is not intended for children under the age of 13. We do not knowingly collect data
        from children. If you believe we have collected data from a child, please contact us
        immediately.
      </p>

      <h2>7. Third-Party Links and Services</h2>
      <p>
        SpoFlex may contain links to third-party websites or services. We are not responsible for
        the privacy practices of such third parties.
      </p>

      <h2>8. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. You will be notified of significant
        changes through the app or via email.
      </p>

      <h2>9. Contact Us</h2>
      <p>If you have questions or concerns about this Privacy Policy, contact us at:</p>
      <p>
        <b>Email:</b> <a href="mailto:support@spoflex.com">support@spoflex.com</a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
